/* @ngInject */

export default (
  $q,
  $rootScope,
  $scope,
  $timeout,
  $stateParams,
  $mdUtil,
  $location,
  $anchorScroll,
  webpage,
  eventService,
  helperService,
  changesService,
  navigationService,
  uiService,
  jsonFactory,
  lendersService,
  contactService,
  contactsService,
  Contact,
  Employment,
  incomeService,
  householdsService,
  assetsService,
  liabilitiesService,
  insurancesService,
  CONTACT,
  GOOGLEMAPS
) => {
  $scope.Model = {
    countries: [],
    organizationCountry: '',
    currentContact: {},
    availableContacts: [],
    googleAutocompleteOptions: {},
    availableSections: ['details', 'income', 'expenses', 'assets', 'liabilities', 'insurance'],
    activeSection: 'details',
    availableIncomeTypes: incomeService.getAvailableIncomeTypes(),
    availableAssetTypes: assetsService.getAvailableAssetTypes(),
    availableLiabilityTypes: [],
    availableInsuranceTypes: [],
    isNewContact: $stateParams.id,
    otherDateFormat: $rootScope.CurrentDateFormatSecondary(),
    isProcessing: false,
    changedData: '',
    isReady: false
  };

  $rootScope.$on('$stateChangeStart', (ev, toState, toParams) => {
    $scope.Model.toState = toState;
    $scope.Model.toParams = toParams;
  });

  /*
   * Set webpage Title
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');

  /*
   * Set date localization
   * --------------------------------------------------------------------------------
   */
  $scope.otherFormat = {
    formatDate: (date) => {
      const m = moment(date);
      return m.isValid()
        ? m.tz($rootScope.CurrentTimeZone()).format($scope.Model.otherDateFormat)
        : '';
    }
  };

  /*
   * Methods
   * --------------------------------------------------------------------------------
   */
  const loadLendersPerCountry = () => {
    const deferred = $q.defer();
    lendersService
      .getAvailable({
        cca2: [helperService.getOrganizationCountry().cca2]
      })
      .then((lenders) => {
        if (lenders && lenders.length) {
          $scope.Model.availableLendersPerCountry = lenders;
        }
        deferred.resolve(lenders);
      });
    return deferred.promise;
  };

  const loadCountries = () => {
    const deferred = $q.defer();
    jsonFactory.getCountries().then((data) => {
      $scope.Model.countries = data;
      $scope.Model.organizationCountry =
        $rootScope.CurrentOrganization.organization.location !== undefined
          ? $rootScope.CurrentOrganization.organization.location.name.common
          : '';
      deferred.resolve(data);
    });
    return deferred.promise;
  };

  const loadOccupations = () => {
    const deferred = $q.defer();
    jsonFactory.getOccupations().then((data) => {
      $scope.Model.occupations = data;
      deferred.resolve(data);
    });
    return deferred.promise;
  };

  const loadIndustries = () => {
    const deferred = $q.defer();
    jsonFactory.getIndustries().then((data) => {
      $scope.Model.industries = data;
      deferred.resolve(data);
    });
    return deferred.promise;
  };

  const loadContact = (idContact) => {
    const deferred = $q.defer();
    contactService.readContact({ id: idContact }).then((contact) => {
      $scope.Model.currentContact = contact;
      deferred.resolve(contact);
    });
    return deferred.promise;
  };

  const loadContacts = (idContacts) => {
    const deferred = $q.defer();
    contactsService
      .getSpecific({ idContacts, isActive: true, fields: CONTACT.FIELDS.WTF_LIST })
      .then((contacts) => {
        $scope.Model.availableContacts = contacts;
        deferred.resolve(contacts);
      });
    return deferred.promise;
  };

  const initialize = () => {
    loadLendersPerCountry();
    $scope.Model.googleAutocompleteOptions = {
      componentRestrictions: GOOGLEMAPS.restrictToCountries
    };
    loadCountries()
      .then(() => {
        if ($scope.Model.organizationCountry === 'Australia') {
          return $q.all(loadOccupations(), loadIndustries());
        }
        return true;
      })
      .then(() => {
        if ($stateParams.id !== '0') {
          loadContact($stateParams.id).then(() => {
            webpage.pageTitle(`Edit contact ${$scope.Model.currentContact.getName()}`);

            $scope.getLiabilityTypes();
            $scope.getInsuranceTypes();

            if (!$scope.Model.currentContact.isCompany) {
              if (
                $scope.Model.currentContact.person &&
                $scope.Model.currentContact.person.employments &&
                !$scope.Model.currentContact.person.employments.length
              ) {
                $scope.Model.currentContact.person.employments.push(Employment.blank(true));
              }

              if (
                !$scope.Model.currentContact.isCompany &&
                $scope.Model.currentContact.person &&
                $scope.Model.currentContact.person.information &&
                $scope.Model.currentContact.person.information.idSpouse &&
                $scope.Model.currentContact.person.information.idSpouse !== ''
              ) {
                loadContacts($scope.Model.currentContact.person.information.idSpouse);
              }

              // if (
              //   !$scope.Model.currentContact?.expenses?.length &&
              //   $scope.Model.currentContact?.id
              // ) {
              //   householdsService.addHousehold({
              //     expenses: $scope.Model.currentContact?.expenses
              //   });
              //   if ($scope.Model.currentContact?.expenses?.length) {
              //     $scope.Model.currentContact.expenses[0].idContacts.push(
              //       $scope.Model.currentContact.id
              //     );
              //     $scope.saveContact($scope.Model.currentContact);
              //   }
              // }
            } else if (
              $scope.Model.currentContact.company &&
              $scope.Model.currentContact.company.individuals &&
              $scope.Model.currentContact.company.individuals.length
            ) {
              const idContacts = _.flatten(
                _.uniq(_.map($scope.Model.currentContact.company.individuals, 'idContact'))
              );
              if (idContacts.length) {
                loadContacts(idContacts);
              }
            }

            $timeout(() => {
              $scope.Model.isProcessing = true;
              $scope.Model.isReady = true;
            });
          });
        } else {
          webpage.pageTitle('Add New Contact');

          $scope.Model.currentContact = Contact.blank();
          $scope.Model.currentContact.isCompany = $stateParams.type === 'company';
          $scope.getLiabilityTypes();
          $scope.getInsuranceTypes();
          $scope.Model.isReady = true;
        }
      });
  };

  initialize();

  /*
   * Contact edit - Switch UI Section
   * --------------------------------------------------------------------------------
   */
  $scope.showSection = (section) => {
    if ($scope.Model.currentContact.getName() !== 'N/A') {
      $scope.Model.activeSection = section;
    } else {
      uiService.toast({
        text: {
          p1: $scope.Model.currentContact.isCompany ? 'Field' : 'Fields',
          p2: $scope.Model.currentContact.isCompany ? 'name' : 'first name and surname',
          p3: $scope.Model.currentContact.isCompany ? 'is required' : 'are required'
        },
        warn: true
      });
    }
  };

  $scope.getNumberOfSection = (section) => {
    const idx = $scope.Model.availableSections.indexOf(section);
    return idx + 1;
  };

  $scope.previous = (section) => {
    const idx = $scope.Model.availableSections.indexOf(section);
    $scope.Model.activeSection =
      section !== 'details' ? $scope.Model.availableSections[idx - 1] : section;
    $scope.showSection($scope.Model.activeSection);
    $location.hash('top');
    $anchorScroll();
  };

  $scope.next = (section) => {
    if ($scope.Model.currentContact.getName() !== 'N/A') {
      const idx = $scope.Model.availableSections.indexOf(section);
      $scope.Model.activeSection =
        $scope.Model.availableSections[idx + 1] !== undefined
          ? $scope.Model.availableSections[idx + 1]
          : $scope.Model.availableSections[idx];
      $scope.showSection($scope.Model.activeSection);
      $location.hash('top');
      $anchorScroll();
    } else {
      uiService.toast({
        text: {
          p1: $scope.Model.currentContact.isCompany ? 'Field' : 'Fields',
          p2: $scope.Model.currentContact.isCompany ? 'name' : 'first name and surname',
          p3: $scope.Model.currentContact.isCompany ? 'is required' : 'are required'
        },
        warn: true
      });
    }
  };

  $scope.isLastSection = () => {
    const idx = $scope.Model.availableSections.indexOf($scope.Model.activeSection);
    return idx === $scope.Model.availableSections.length - 1;
  };

  /*
   * Contact edit - Income
   * --------------------------------------------------------------------------------
   */
  $scope.isContactCompanyOrSelfEmployed = () =>
    $scope.Model.currentContact?.isCompany ||
    $scope.Model.currentContact?.isCurrentEmployerSelfEmployed();

  /*
   * Contact edit - Income
   * --------------------------------------------------------------------------------
   */
  $scope.incomeAdd = (incomeType, idContact, idEmployer) => {
    incomeService.incomeAdd(
      $scope.Model.currentContact.income,
      incomeType,
      idContact,
      idEmployer
    );
    if (idContact !== null && idEmployer !== null) {
      $scope.saveIncome($scope.Model.currentContact.income);
    }
  };

  $scope.saveIncome = $mdUtil.debounce((data) => {
    $scope.Model.dataType = data?.dataType || '';
    $scope.Model.currentContact.income = data?.income;
    $scope.saveContact($scope.Model.currentContact);
  }, 1500);

  /*
   * Contact edit - Expenses
   * --------------------------------------------------------------------------------
   */
  $scope.saveExpenses = $mdUtil.debounce((data) => {
    $scope.Model.dataType = data?.dataType || '';
    $scope.Model.currentContact.expenses = data?.expenses;
    $scope.saveContact($scope.Model.currentContact);
  }, 1500);

  /*
   * Contact edit - Assets
   * --------------------------------------------------------------------------------
   */
  $scope.assetAdd = (assetType) => {
    assetsService.assetAdd($scope.Model.currentContact.assets, assetType, [
      $scope.Model.currentContact
    ]);
  };

  $scope.saveAssets = $mdUtil.debounce((data) => {
    $scope.Model.dataType = data?.dataType || '';
    $scope.Model.currentContact.assets = data?.assets;
    $scope.saveContact($scope.Model.currentContact);
  }, 1500);

  /*
   * Contact edit - Liabilities
   * --------------------------------------------------------------------------------
   */
  $scope.getLiabilityTypes = () => {
    $scope.Model.availableLiabilityTypes = liabilitiesService.getLiabilityTypes(
      $scope.Model.currentContact.assets
    );
  };

  $scope.liabilityAdd = (liabilityType) => {
    liabilitiesService.liabilityAdd($scope.Model.currentContact.liabilities, liabilityType, [
      $scope.Model.currentContact
    ]);
  };

  $scope.saveLiabilities = $mdUtil.debounce((data) => {
    $scope.Model.dataType = data?.dataType || '';
    $scope.Model.currentContact.liabilities = data?.liabilities;
    $scope.saveContact($scope.Model.currentContact);
  }, 1500);

  /*
   * Contact edit - Insurance
   * --------------------------------------------------------------------------------
   */
  $scope.getInsuranceTypes = () => {
    $scope.Model.availableInsuranceTypes = insurancesService.getInsuranceTypes({
      assets: $scope.Model.currentContact.assets
    });
  };

  $scope.insuranceAdd = (insuranceType) => {
    insurancesService.insuranceAdd(insuranceType);
  };

  $scope.saveInsurances = $mdUtil.debounce((insurances) => {
    $scope.Model.currentContact.insurances = insurances;
    $scope.saveContact($scope.Model.currentContact);
  }, 1500);

  /*
   * Contact edit - Back
   * --------------------------------------------------------------------------------
   */
  $scope.back = ($event) => {
    $event.stopPropagation();
    navigationService.goToPreviousState();
  };

  /*
   * Contact edit - Register and configure Changes service
   * --------------------------------------------------------------------------------
   */
  $scope.toggleChanges = () => {
    $scope.Model.isProcessing = true;
    changesService.change();
  };

  const validate = () => {
    if ($scope.Model.currentContact.isCompany) {
      return _.get($scope.Model.currentContact, 'company.information.name');
    }
    return (
      _.get($scope.Model.currentContact, 'person.information.firstName') &&
      _.get($scope.Model.currentContact, 'person.information.familyName')
    );
  };

  const invalid = () => {
    if ($scope.Model.toState && $scope.Model.toParams) {
      const state = $scope.Model.toState;
      const params = $scope.Model.toParams;
      $scope.Model.toState = false;
      $scope.Model.toParams = false;
      return eventService.formWarning({ toState: state, toParams: params });
    }
    return uiService.toast({
      text: {
        p1: 'Contact',
        p2: $scope.Model.currentContact.isCompany ? 'Name' : 'First name and family name',
        p3: $scope.Model.currentContact.isCompany ? 'is required' : 'are required'
      },
      warn: true
    });
  };

  changesService.init({ useFinishOnInterval: true });
  changesService.onValidate(validate);
  changesService.onInvalid(invalid);

  /*
   * Contact edit - Save
   * --------------------------------------------------------------------------------
   */
  const saveChanges = () => {
    if (!$scope.Model.currentContact.id) {
      return contactService.createContact($scope.Model.currentContact).then((result) => {
        if (result.status) {
          $scope.Model.currentContact.id = result.id;
          contactsService.clearCache();
          uiService.toast({
            text: {
              p1: 'Contact',
              p2: $scope.Model.currentContact.getName(),
              p3: 'saved successfully'
            }
          });
        }
      });
    }
    return contactService.updateContact($scope.Model.currentContact).then((result) => {
      if (result.status) {
        $scope.Model.changedData = $scope.Model.dataType;
        $scope.Model.dataType = '';
        contactsService.clearCache();
        uiService.toast({
          text: {
            p1: 'Contact',
            p2: $scope.Model.currentContact.getName(),
            p3: 'updated successfully'
          }
        });
      }
    });
  };

  $scope.saveContact = (contact) => {
    $scope.Model.currentContact = contact;
    $scope.toggleChanges();
  };

  changesService.onFinish(saveChanges);
};
